// Author YuJiaBei
// Date 2020-02-28 15:20

class InspectionRecordForInspection {
    constructor({
                    id = null,
                    emArchBasicDataCode = '',
                    inspectionStandardId = '',
                    inspectionScheduleDetailId = '',
                    inspectionWorkOrderId = '',
                    inspectionResultId = '',
                    recordValue = '',
                    recorder = '',
                    abnormalDescription = '',
                    abnormalTime = ''
                }
                //todo:试试去掉下面的={}会怎么样
                    = {}) {
        this.id = id;
        this.emArchBasicDataCode = emArchBasicDataCode;
        this.inspectionStandardId = inspectionStandardId;
        this.inspectionScheduleDetailId = inspectionScheduleDetailId;
        this.inspectionWorkOrderId = inspectionWorkOrderId;
        this.inspectionResultId = inspectionResultId;
        this.recordValue = recordValue;
        this.recorder = recorder;
        this.abnormalDescription = abnormalDescription;
        this.abnormalTime = abnormalTime;
    }
}

function newEntity() {
    return new InspectionRecordForInspection();
}

const filter = {
    emArchBasicDataCodeFilter : "",
    inspectionWorkOrderIdFilter : "",
    inspectionScheduleDetailIdFilter : "",
    inspectionResultIdFilter : "",
    recordValueFilter : "",
    inspectionRecordProcessStatusCodeFilter : "",
    createdTimeGreatThanFilter : "",
    createdTimeLessThanFilter : "",
    workflowQueryTypeFilter : "",
    recorderFilter : "",
    abnormalTimeFilter : "",
    handleTimeFilter : ""
};

const entityFormConfigs = [
    {
        key: 'inspectionResultId',
        label: 'label.em.inspection.inspectionRecord.entity.inspectionResultId',
        form: {
            type: 'entitySelect',
            entity: 'inspectionResult',
            showLabelSelectOne: true,
            correspondingField: 'id',
            required: false
        }
    },
    {
        key: 'recordValue',
        label: 'label.em.inspection.inspectionRecord.entity.recordValue',
        sortable: true,
        form: {
            type: 'inputNumber',
            required: false
        }
    },
    {
        key: 'abnormalDescription',
        label: 'label.em.inspection.inspectionRecord.entity.abnormalDescription',
        sortable: true,
        form: {
            type: 'textarea',
            required: false
        }
    }
]

export {InspectionRecordForInspection,newEntity, filter, entityFormConfigs}
